import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import "./OndemandScreen.scss";
import VideoCarousel from "../../components/ReusableComponents/VideoCarousel/VideoCarousel";
import CoachProfileBox from "../../components/ReusableComponents/CoachProfileBox/CoachProfileBox";
import { selectIcon, SVG } from "../../components/UI/selector";
import ApiURL from "../../services/ApiURL";
import { CarouselDataApi, accessTokenApi } from "../../services/CallApi";
import { OndemandHocCarousel } from "../../components/ReusableComponents/VideoUI/VideoUI";
import { ErrorUI } from "../../components/UI/Modals/Modals";
import CategoryCarousel from "../../components/ReusableComponents/CategoryCarousel/CategoryCarousel";
import ClassesForCategoryCarousel from "../../components/ReusableComponents/ClassesForCategoryCarousel/ClassesForCategoryCarousel";

const OndemandScreen = ({ ...props }) => {
  const ref = useRef(null);
  const history = useHistory();
  const [CarouselList, UpdateCarouselList] = useState([]);
  const [startBtn, setStartBtn] = useState(true);
  const { defaultGym, sections } = useSelector(
    (state) => state.profile.profileData
  );
  const [classCarousel, updateClassCarousel] = useState(0);

  const featuredCategoriesUI = sections.categories.length
    ? sections.categories.map((category, index) => (
      <ClassesForCategoryCarousel key={index} category={category} />
    ))
    : null;

  useEffect(() => {
    if (defaultGym) {
      getCarouselData([defaultGym.gym_id]);
    }
  }, [defaultGym]);

  const getCarouselData = (gymIds) => {
    const payload = {
      limit: 100,
      offset: 0,
      gym_ids: JSON.stringify(gymIds),
      is_gym_status_pending: false,
    };
    CarouselDataApi(ApiURL._ondemandActivities, payload).then(async (res) => {
      if (res.status) {
        UpdateCarouselList([...res.list]);
      } else {
        ErrorUI(res.list, () => {
          getCarouselData(gymIds);
        });
      }
    });
  };

  const leftNavigate = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
    if (classCarousel <= 0) {
    } else {
      updateClassCarousel(classCarousel - 1);
    }
    // console.log(classCarousel-1)
  };
  const RightNavigate = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
    updateClassCarousel(classCarousel + 1);
    // console.log(classCarousel+1)
  };

  const handleOnDemand = (el) => {
    checkUserValidity('userValidate', el);
  }
  const checkUserValidity = (userValidate, el) => {
    accessTokenApi().then(async (res) => {
      if (res.status) {
        res.data.gyms.map((gym) => {
          if (gym.gym_id === el.gym_id) {
            if (gym.linked_status === 0) {
              setStartBtn(true)
              if (userValidate) {
                startOndemand(el);
              }
            }
            else {
              setStartBtn(false);
              if (userValidate) {
                ErrorUI(
                  "It seems you are not member of this studio.",
                  null,
                  {},
                )
              }
            }
          }

        });
      } else {
        if (res.logout) {
        } else {
          // modalPopup.cross = false;
          //ErrorUI(res.err.response, () => getAccessTokenLoginData());
        }
      }
    });
  }

  const startOndemand = (data) => {
    const {
      activity_id,
      duration_in_minutes,
      heartrate_required,
      workout_builder,
      leaderboard_type,
      gym_id,
      ended_at,
      started_at,
      playback_url,
      ondemand_videos,
      logo_thumb,
    } = data;
    const ondemandData = {
      activity_id: activity_id,
      duration_in_minutes: Math.round(duration_in_minutes * 1000),
      is_ondemand_workout: true,
      status: "PLAY",
      time_elapsed: 0,
    };
    const workoutData = {
      heartrate_required,
      leaderboard_type,
      workout_builder,
      gym_id,
      ended_at,
      started_at,
      playback_url,
      ondemand_videos,
      logo_thumb,
      activity_id: activity_id,
    };
    console.log("ondemandData", ondemandData);
    console.log("workoutData", workoutData);
    // console.log("isOndemand", isOndemand);
    localStorage.setItem("ondemandData", JSON.stringify(ondemandData));
    localStorage.setItem("workoutData", JSON.stringify(workoutData));
    history.push("/Ondemand");
  };

  const CarouselListUI = CarouselList.length
    ? CarouselList.map((el, index) => (
      <div key={index} className="OndemandScreenBanner">
        <img
          className="OndemandBannerImage"
          src={el.activity_logo_original}
        />
        <div className="OndemandBannerDetail">
          <h1 className="OndemandBannerTitle">{el.name}</h1>
          <p className="OndemandBannercoach">With {el.first_name}</p>
          <p className="OndemandBannerDesc">{el.description}</p>
          <div className="OndemandBannerButtonRow">
            {!startBtn ?
              <button
                className="OndemandBannerButtonActive"
                onClick={() => handleOnDemand(el)}
              >
                START CLASS
              </button>
              : <button
                className="OndemandBannerButtonActive"
                onClick={() => handleOnDemand(el)}
              >
                START CLASS
              </button>}
            <button
              className="OndemandBannerButtonDisable"
              onClick={() => history.push(`/ClassInfo/${el.activity_id}`)}
            >
              MORE INFO
            </button>
          </div>
        </div>
        <div className="OndemandScreenBannerGradient"></div>
      </div>
    ))
    : [];

  return (
    <div className="OndemandScreen">
      {CarouselListUI.length ? (
        <div className="OndemandScreenBannerContainerParent">
          <div className="OndemandScreenBannerContainer" ref={ref}>
            {CarouselListUI}
          </div>
          <div className="OndemandBannerNavigation">
            <div
              className="navigatorCircle prevCircle"
              slidenum={classCarousel}
              onClick={() => leftNavigate(-window.innerWidth)}
            >
              <SVG src={selectIcon("leftArrow")} />
            </div>
            <div
              className="navigatorCircle nextCircle"
              slidenum={classCarousel}
              onClick={() => RightNavigate(window.innerWidth)}
            >
              <SVG src={selectIcon("rightArrow")} />
            </div>
          </div>
        </div>
      ) : null}
      {defaultGym && (
        <OndemandHocCarousel
          heading="RECOMMENDED FOR YOU"
          url={"_recommendedOndemandActivities"}
          gymIds={[defaultGym.gym_id]}
          tileSize="small"
        />
      )}
      {defaultGym && (
        <OndemandHocCarousel
          heading="New"
          url={"_newOndemandActivities"}
          gymIds={[defaultGym.gym_id]}
          showNewTag={true}
        />
      )}
      {defaultGym && (
        <CoachProfileBox url={"_coachesList"} gymIds={[defaultGym.gym_id]} />
      )}
      {defaultGym && <CategoryCarousel shouldHitApi={true} />}
      {defaultGym && featuredCategoriesUI}
      {defaultGym && (
        <OndemandHocCarousel
          heading="DO IT AGAIN"
          url={"_ondemandActivities"}
          gymIds={[defaultGym.gym_id]}
        />
      )}
    </div>
  );
};

export default OndemandScreen;
